var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.display404)?_c('Page404'):(!_vm.display404)?_c('router-view'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }